const activeAutoSizeOwners = new Map<string, symbol | null>();

/**
 * Marks a chat block created by this browser session as eligible for one
 * content-height write. This state is intentionally memory-only: reloading a
 * page clears it, so hydration and delayed reload content can never create a
 * Yjs geometry transaction.
 */
export function registerActiveAIChatBlockAutoSize(blockId: string) {
  activeAutoSizeOwners.set(blockId, null);
}

export function claimActiveAIChatBlockAutoSize(blockId: string, owner: symbol) {
  if (!activeAutoSizeOwners.has(blockId)) return false;
  const currentOwner = activeAutoSizeOwners.get(blockId);
  if (currentOwner && currentOwner !== owner) return false;
  activeAutoSizeOwners.set(blockId, owner);
  return true;
}

export function releaseActiveAIChatBlockAutoSize(
  blockId: string,
  owner: symbol
) {
  if (activeAutoSizeOwners.get(blockId) === owner) {
    activeAutoSizeOwners.set(blockId, null);
  }
}

export function completeActiveAIChatBlockAutoSize(
  blockId: string,
  owner: symbol
) {
  if (activeAutoSizeOwners.get(blockId) === owner) {
    activeAutoSizeOwners.delete(blockId);
  }
}
